import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { HeadingThree, BodyText } from '../../components/typography';
import PhoneVerificationRequiredSC from './phone-verification-required.styled';
import * as ActionCreators from '../../redux/action';
import { LS_ACCESS_TOKEN, LS_REFRESH_TOKEN } from '../../constants';

const PhoneVerificationRequired = ({ logOut }) => {
  useEffect(() => {
    // Zakázať scrollovanie
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleLogoutAndRedirect = () => {
    // Vymazať tokeny
    localStorage.removeItem(LS_ACCESS_TOKEN);
    localStorage.removeItem(LS_REFRESH_TOKEN);

    // Odhlásenie cez Redux
    logOut();

    // Presmerovanie na root (login page)
    window.location.href = '/';
  };

  return (
    <PhoneVerificationRequiredSC>
      <div className="verification-container">
        <div className="verification-content">
          <HeadingThree className="verification-title">
            <FormattedMessage id="phone_verification_block_title" />
          </HeadingThree>
          <BodyText className="verification-message">
            <FormattedMessage id="phone_verification_block_message" />{' '}
            <button
              type="button"
              onClick={handleLogoutAndRedirect}
              className="login-link"
            >
              <FormattedMessage id="phone_verification_block_here" />
            </button>
            .
          </BodyText>
          <BodyText className="verification-problems">
            <FormattedMessage id="phone_verification_block_problems" />{' '}
            <a
              href="https://wishmaker.sk/kontakt"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              <FormattedMessage id="wishmaker_contact_page" />
            </a>
            .
          </BodyText>
        </div>
      </div>
    </PhoneVerificationRequiredSC>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logOut: ActionCreators.logOut,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(PhoneVerificationRequired);

